/** Helpers for the welcome display-name step. */

export const ONBOARDING_DISPLAY_NAME_MAX_LENGTH = 50;

/** Extra input buffer above validated max length (browser maxLength). */
export const ONBOARDING_DISPLAY_NAME_INPUT_BUFFER = 10;

/**
 * First token from Firebase Auth `displayName` (Google full name → voornaam).
 * @param {string | null | undefined} displayName
 * @returns {string}
 */
export function firstNameFromAuthDisplayName(displayName) {
  if (typeof displayName !== 'string') {
    return '';
  }
  const trimmed = displayName.trim();
  if (!trimmed) {
    return '';
  }
  return trimmed.split(/\s+/)[0] ?? '';
}

/**
 * @param {import('firebase/auth').User | null | undefined} user
 * @returns {string}
 */
export function getDefaultDisplayNameFromAuthUser(user) {
  return firstNameFromAuthDisplayName(user?.displayName ?? '');
}

/**
 * @param {string} value
 * @returns {{ ok: true; value: string } | { ok: false; reason: 'empty' | 'tooLong' }}
 */
export function validateOnboardingDisplayName(value) {
  const trimmed = (value ?? '').trim();
  if (!trimmed) {
    return { ok: false, reason: 'empty' };
  }
  if (trimmed.length > ONBOARDING_DISPLAY_NAME_MAX_LENGTH) {
    return { ok: false, reason: 'tooLong' };
  }
  return { ok: true, value: trimmed };
}

/**
 * @param {unknown} raw
 * @returns {string}
 */
export function normalizeProfileDisplayName(raw) {
  return typeof raw === 'string' ? raw.trim() : '';
}
